import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import EmpresasService from "services/empresas";

/** Select de empresa do grupo (cadastro em Empresas). Para usar com formik. */
export default function SelectEmpresa({
  formik,
  name = "empresa",
  label = "Empresa",
  ...props
}) {
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    EmpresasService.list()
      .then(({ data }) => setEmpresas(data || []))
      .catch(() => setEmpresas([]));
  }, []);

  return (
    <TextField
      id={name}
      name={name}
      label={label}
      value={formik.values[name] || ""}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] && formik.errors[name]}
      select
      SelectProps={{ native: true }}
      InputLabelProps={{ shrink: true }}
      {...props}
    >
      <option value=""></option>
      {empresas
        .filter((e) => e.ativo !== false || e._id === formik.values[name])
        .map((e) => (
          <option key={e._id} value={e._id}>
            {e.nomeFantasia || e.razaoSocial}
          </option>
        ))}
    </TextField>
  );
}
